import { Link } from "@viagogo/core/ui";
import { useContent } from "src/shared/components/content";
import { PE_KEYS } from "src/shared/constants/PageEventKeys";
import { PE_TYPE } from "src/shared/constants/PageEventTypes";
import { useStorePageEvent } from "src/shared/hooks/useStorePageEvent";
import { useWriteUrl } from "src/shared/utils/url-builder";

/**
 *
 *Wrapper to link elemnts to Fan Protect Page
 */
export const FanProtectLink = ({ children }) => {
  const storePageEvent = useStorePageEvent();
  const fanProtectLinkTitle = useContent("cid$#1907087#");
  const promiseUrl = useWriteUrl("/promise");

  const handleClick = () => {
    storePageEvent(PE_TYPE.CLICK, PE_KEYS.FAN_PROTECT_LEARN_MORE, "home-fan-protect-link");
  };

  return (
    <Link title={fanProtectLinkTitle} onClick={handleClick} newTab url={promiseUrl}>
      {children}
    </Link>
  );
};
